import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { TRAVEL_TYPE_LABEL, TRAVEL_TYPES, TravelType } from "../../types";

const DESCRIPTION: Record<TravelType, string> = {
  domestic:
    "Within one country - you'll enter the country and the start and end city.",
  international:
    "Between two countries - you'll enter the starting and destination country."
};

// The employee's explicit Domestic / International choice. It decides which
// rate of the policy applies and which location fields the form asks for
// next (see TripLocationFields). Deliberately starts unselected (value "")
// rather than defaulting to one, so nobody submits a type they never chose.
// Shared by the New Request wizard and the Request Advance form.
export function TravelTypePicker({
  value,
  onChange,
  disabled,
  label = "Is this trip Domestic or International?"
}: {
  value: TravelType | "";
  onChange: (value: TravelType) => void;
  disabled?: boolean;
  label?: string;
}) {
  return (
    <div className="space-y-1.5">
      <Label>{label}</Label>
      <div
        className="grid gap-3 sm:grid-cols-2"
        role="radiogroup"
        aria-label={label}
      >
        {TRAVEL_TYPES.map((t) => (
          <button
            key={t}
            type="button"
            role="radio"
            aria-checked={value === t}
            disabled={disabled}
            onClick={() => onChange(t)}
            className={cn(
              "rounded-md border p-4 text-left text-sm transition-colors disabled:opacity-60 sm:p-3",
              value === t
                ? "border-primary bg-primary/5 ring-1 ring-primary"
                : "border-border hover:bg-muted/50"
            )}
          >
            <p className="font-medium">{TRAVEL_TYPE_LABEL[t]}</p>
            <p className="mt-0.5 text-xs text-muted-foreground">
              {DESCRIPTION[t]}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
}
